import { createMutation } from '@/mutations'
import {
  updateUserProfile,
  type UpdateUserProfileRequest,
} from '@/features/auth/api/profile'

/** `PUT /user/profile` answers an empty body; the page refetches profile-data. */
export const useUpdatePersonalDataMutation = () => {
  return createMutation<void, UpdateUserProfileRequest>({
    mutationFn: async (payload) => {
      await updateUserProfile(payload)
    },
    invalidateQueries: (key) => Array.isArray(key) && key[0] === 'user-profile',
  })
}
